import { Heading as ChakraHeading } from '@chakra-ui/react';

type HeadingProps = React.ComponentProps<any>;

const Heading = ({ children, ...props }: Readonly<HeadingProps>) => {
  return <ChakraHeading {...props}>{children}</ChakraHeading>;
};

export default Heading;
